import {useFormContext} from "react-hook-form";
import {Grid, InputLabel, useTheme} from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";
import {MuiRhfSelectField} from "./MuiRhfSelectField";
import {wideFormFieldStyles} from "./UseWideFormFieldStyles";

export function WideFormSelectField<LIST_TYPE>(props: {
  name: string,
  label: string,
  list: LIST_TYPE[];
  getListLabel?: (entry: LIST_TYPE) => string;
  getListKey?: (entry: LIST_TYPE) => string | number;
  noSelectionText?: string;
  allowEmpty?: boolean,
  readonly?: boolean
}) {
  const {getValues} = useFormContext();
  const theme = useTheme();

  return (
    <Grid container={true} sx={wideFormFieldStyles(theme).container}>
      <Grid item={true} xs={4} lg={3} xl={2} sx={wideFormFieldStyles(theme).labelContainer}>
        <InputLabel htmlFor={props.name} sx={wideFormFieldStyles(theme).label}>{props.label}</InputLabel>
      </Grid>
      <Grid item={true}>
        {props.readonly &&
          <Typography variant={"body1"} sx={wideFormFieldStyles(theme).value}>
            {props.getListLabel ? props.getListLabel(getValues(props.name)) : getValues(props.name)}
          </Typography>
        }
        {!props.readonly &&
          <MuiRhfSelectField
            id={props.name}
            name={props.name}
            label={props.label}
            list={props.list}
            getListLabel={props.getListLabel}
            getListKey={props.getListKey}
            fullWidth={false}
            variant="standard"
            disabled={props.readonly}
          />
        }
      </Grid>
    </Grid>
  )
}
